/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'jquery',
	'underscore',
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'react-dom',
	'react',
	'@ba/ba-ui-carbon-toolkit'
], function($, _, View, ReactDOM, React, Toolkit) {
	'use strict';

	const { TabPanel } = Toolkit;
	const { Tabs } = Toolkit;

	class VisTabControl extends React.Component {
		'use strict';
		/* eslint react/prop-types: 0 */

		constructor(props) {
			super(props);
			this.state = _.clone(props.state);
		}

		/**
		 * Render the tab control
		 */
		render() {
			return <Tabs selected={this.getSelectedId()} onChange={this._onChange.bind(this)}>{this._renderPanels()}</Tabs>;
		}

		/**
		 * Set the selected tab
		 */
		select(tabId) {
			this.setState({ selectedTab: tabId || this.props.selectedTab });
		}

		/**
		 * Get the selected tab identifier
		 *
		 * @return unique identifier of the selected tab
		 */
		getSelectedId() {
			return this.state.selectedTab;
		}

		_renderPanels() {
			// render each tab entries as a TabPanel with the given identifier and label
			return _.map(this.props.entries, (entry) => {
				return <TabPanel key={entry.id} id={entry.id} label={entry.label}/>;
			});
		}

		_onChange(tabId) {
			// set the selectedTab to state
			this.select(tabId);

			// find the tab entry of the selected tab and invoke the callback (if available)
			const entry = _.findWhere(this.props.entries, { id: tabId });
			if (entry && entry.onChange) {
				entry.onChange(tabId);
			}
		}
	}

	const VisTabs = View.extend({

		className: 'visTabsView',

		init: function() {
			VisTabs.inherited('init', this, arguments);
		},

		/**
		 * Attach the tabs to a DOM element
		 *
		 * @param {Element} element - The parent DOM element to place the tabs
		 */
		placeAt: function(element) {
			// remove the previous render (if any)
			$(element).find('.visTabsView').remove();

			this.$el.prependTo(element);
		},

		/**
		 * Create the tabs with the given array of tab entries
		 * The tab entry is expected to be provided in the following form:
		 * Entry: {
		 * 		id: <unique identifier of the tab>
		 *		label: <display label of the tab>
		 *		onChange: <callback function called on tab selection> [optional]
		 * }
		 *
		 * @param {Entry[]} entries - array of tab definition entries
		 * @param {string} selectedTab - identifier of the default selected tab [optional]
		 */
		createTabs: function(entries, selectedTab) {
			this.entries = entries;
			// if there is not selectedTab, simply start with selecting the first tab entry
			const initState = { selectedTab: selectedTab || (entries && entries.length ? entries[0].id : null) };
			this.ctrl = ReactDOM.render(<VisTabControl entries={entries} state={initState}/>, this.el);
		},

		reset: function() {
			if (this.ctrl) {
				ReactDOM.unmountComponentAtNode(this.el);

				this.entries = null;
				this.ctrl = null;
			}
		},

		remove: function() {
			this.reset();
			VisTabs.inherited('remove', this, arguments);
		},

		/**
		 * Get the number of tabs
		 *
		 * @return number of tabs entries rendered
		 */
		getTabsCount: function() {
			return this.entries ? this.entries.length : 0;
		},

		/**
		 * Select a tab with the given tab identifier
		 *
		 * @param {string} tabId - unique tab identifier to select
		 */
		selectTab: function(tabId) {
			if (this.ctrl) {
				if (this.ctrl.getSelectedId() !== tabId) {
					this.ctrl.select(tabId);
					this.ctrl.render();
				}
			}
		}
	});

	return VisTabs;
});
